<template>
  <AllPostLoginModal
    @second-cta="handleSecondCTAClicked"
    @main-cta="handleMainCTAClicked"
    @seen="seenAnnouncement"
  />
  <PostLoginModal
    @second-cta="handleSecondCTAClicked"
    @main-cta="handleMainCTAClicked"
    @seen="seenAnnouncement"
  />
</template>

<script setup>
import AllPostLoginModal from "@/pages/Dashboard/reusables/AllPostLoginModal.vue";
import PostLoginModal from "@/pages/Dashboard/reusables/PostLoginModal.vue";
import { useQuery, useMutation } from "@urql/vue";
import {
  POST_LOGIN_ANNOUNCEMENT,
  CREATE_POST_LOGIN_ANALYTICS,
  UPDATE_POST_LOGIN_SEEN_STATUS,
} from "@/constants/graphql";
import { Modal } from "bootstrap";
import { watch, computed, onMounted } from "vue";
import { usePostLoginAnnouncement } from "@/stores/postLoginAnnouncement.js";
import { convertToLocal } from "@/constants/dateUtils.js";
import { useBrandStore } from "@/stores/brand";

const postLoginStore = usePostLoginAnnouncement();
const brandStore = useBrandStore();

const brandReady = computed(() => !!brandStore.brand);

const postLoginQuery = useQuery({
  query: POST_LOGIN_ANNOUNCEMENT,
  pause: computed(() => !brandReady.value),
});

postLoginStore.$patch({ postLoginAnnouncementQuery: postLoginQuery });

watch(postLoginQuery.fetching, (fetchStatus) => {
  if (!fetchStatus && postLoginQuery.data.value) {
    const data = postLoginQuery.data.value.postLoginAnnouncement;
    postLoginStore.$patch({
      activated: data.activated,
      templateOrder: data.postLoginAnnouncementOrder,
      postLoginAnnouncementData: data.postLoginTemplates,
    });
  }
});

onMounted(() => {
  const allPostLoginModal = new Modal("#allPostLogin");
  const postLoginModal = new Modal("#postLogin");
  postLoginStore.allPostLoginModal = allPostLoginModal;
  postLoginStore.postLoginModal = postLoginModal;
});

const { executeMutation: createAnalytics } = useMutation(
  CREATE_POST_LOGIN_ANALYTICS
);

const handleSecondCTAClicked = (id) => {
  createPosthogAnalytics("2nd CTA", id);
};

const handleMainCTAClicked = (id) => {
  createPosthogAnalytics("Main CTA", id);
};

const createPosthogAnalytics = async (action, id) => {
  const now = new Date();
  const formattedDate = convertToLocal(now.toISOString());
  const popupDate = new Date(postLoginStore.popupTimestamp);
  const durationSeconds = (now - popupDate) / 1000;

  const args = {
    date: formattedDate,
    duration: parseInt(durationSeconds),
    action: action,
    templateId: id,
  };

  try {
    await createAnalytics(args);
  } catch (e) {
    console.error(e);
  }
};

const { executeMutation: seenPostLoginAnnouncement } = useMutation(
  UPDATE_POST_LOGIN_SEEN_STATUS
);

const pendingSeenIds = new Set();

async function seenAnnouncement(id) {
  if (pendingSeenIds.has(id)) return;

  pendingSeenIds.add(id);

  const announcement = postLoginStore.postLoginAnnouncementData.find(
    (item) => item.id === id
  );
  if (announcement) {
    announcement.seen = true;
  }

  try {
    const result = await seenPostLoginAnnouncement({
      postLoginAnnouncementId: id,
    });

    if (result.data?.updatePostLoginSeenStatus?.errors?.length > 0) {
      console.error(
        "Failed to update seen status:",
        result.data.updatePostLoginSeenStatus.errors
      );
      pendingSeenIds.delete(id);
      if (announcement) {
        announcement.seen = false;
      }
    }
  } catch (error) {
    console.error(
      "An error occurred while marking announcement as seen:",
      error
    );
    pendingSeenIds.delete(id);
    if (announcement) {
      announcement.seen = false;
    }
  }
}
</script>
